import React, { FC } from 'react';
import { TNewsDetailMediaListItem } from '../types/newsDetail.types';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { getThumbnailProps } from '../../../utils/youtubeUtils';
import { getImageField } from '../../../utils/getImageFields';
import { TEditorialImageProps } from '../../@shared/picture/types/editorialImage.types';
import VideoPlayer from '../../@shared/videoPlayer';
import { iconSize } from '../../../constants/icon.constants';
import useMediaQuery from '../../../lib/custom-hooks/useMediaQuery';
import { Breakpoints } from '../../../constants/breakpoints.constants';
import Picture from '../../@shared/picture';

const NewsDetailMediaListItem: FC<{ mediaItem: Partial<TNewsDetailMediaListItem> }> = ({ mediaItem }) => {
  const isDesktop = useMediaQuery(`(min-width: ${Breakpoints['md']}px)`);
  const { image, mobileImage, mediaCaption, mediaDescription, useVideo, video } = mediaItem?.fields || {};
  const canShowVideo = !!(useVideo?.value && video?.value?.href);
  const isMediaExists = !!(canShowVideo || image?.value?.src || mobileImage?.value?.src);
  const { thumbnailImgSrc } = getThumbnailProps(video?.value?.href || '');
  const desktopImageOrThumbnail = getImageField(image, thumbnailImgSrc ?? '', canShowVideo);
  const mobileImageOrThumbnail = getImageField(mobileImage, thumbnailImgSrc ?? '', canShowVideo);
  const editorialImageProps: TEditorialImageProps = {
    desktopImage: desktopImageOrThumbnail,
    mobileImage: mobileImageOrThumbnail,
    desktopTransformation: 'Size1000',
    mobileTransformation: 'Size1000',
    alt: (isDesktop ? desktopImageOrThumbnail?.value?.alt : mobileImageOrThumbnail?.value?.alt) as string | undefined,
  };

  return (
    <>
      <figure className="news-detail-media-list__figure">
        {isMediaExists && (
          <div className="news-detail-media-list__media-wrapper">
            {canShowVideo ? (
              <VideoPlayer
                link={video?.value?.href}
                autoPlay={true}
                showThumbnail={true}
                desktopPlayIconSize={iconSize.xlg}
                mobilePlayIconSize={iconSize.dsk}
                editorialImageProps={editorialImageProps}
                videoPlayerWrapperClassName={'news-detail-media-list__video-wrapper'}
              />
            ) : (
              <Picture editorialImageProps={editorialImageProps} />
            )}
          </div>
        )}
        {mediaCaption && <Text tag="figcaption" field={mediaCaption} className={'news-detail-media-list__media-caption'} />}
      </figure>

      {mediaDescription && (
        <RichText tag="div" field={mediaDescription} className={'news-detail-media-list__media-description rich-text color-primary-link'} />
      )}
    </>
  );
};

export default NewsDetailMediaListItem;
